var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._l(_vm.categories, function(item, key) {
        return [
          _c(
            "div",
            { key: key, staticClass: "aedw-package-section" },
            [
              _c("span", { staticClass: "aedw-package-section-name" }, [
                _vm._v(_vm._s(item.tagline || item.name))
              ]),
              _vm._v(" "),
              _c("PackageList", {
                attrs: {
                  useCustomTemplate: _vm.useCustomTemplate,
                  templateName: _vm.templateName,
                  config: _vm.config,
                  params: _vm.setCategory(item.id),
                  useDefaultGridCols: _vm.useDefaultGridCols,
                  disableGetPackagesOnRender: _vm.disableGetPackagesOnRender
                }
              })
            ],
            1
          )
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }